/**
 * Power Hours — shared department → Confluence routing + visibility.
 *
 * Each department's Power Hours catalogue lives in its own Confluence library. This module
 * is the single source of truth for the three surfaces that expose Power Hours — the global
 * nav, the command palette, and the homepage widget — so the department→URL map and the
 * visibility rule are defined once, not duplicated per surface.
 *
 * Keys are DepartmentIDs matching the Polaris `DepartmentId` enum (which is not shared
 * into uikit): Technology (4), Strategy (5), Design (6), Digital (19). Digital routes to
 * the same Consulting library as Strategy.
 */
export const POWER_HOURS_CONFLUENCE_URLS: Readonly<Record<number, string>> = {
  4: 'https://konradgroup.atlassian.net/wiki/spaces/DEV/pages/6409388061/Power+Hour+Library',
  5: 'https://konradgroup.atlassian.net/wiki/spaces/CONSULTING/pages/6418825257/Power+Hours+Library',
  6: 'https://konradgroup.atlassian.net/wiki/spaces/DPH/pages/6419513396/Power+Hour+Library',
  19: 'https://konradgroup.atlassian.net/wiki/spaces/CONSULTING/pages/6418825257/Power+Hours+Library',
};

/** The Confluence Power Hours library for a department, or `undefined` if it has no library. */
export const getPowerHoursUrl = (departmentId?: number | null): string | undefined =>
  departmentId == null ? undefined : POWER_HOURS_CONFLUENCE_URLS[departmentId];

/**
 * Whether the Power Hours entry should be visible. Visibility is department-only: the
 * user must belong to one of the mapped departments (i.e. have a Confluence library to
 * route to). There is no permission gate.
 */
export const canViewPowerHours = (departmentId?: number | null): boolean =>
  getPowerHoursUrl(departmentId) !== undefined;
